module.exports = __webpack_public_path__ + "img/MA.6d16822d.png";